import { useMemo } from "react";
import { useMsal } from "@azure/msal-react";
import { createApiClient } from "./client";

export function useApiClient() {
  const { instance } = useMsal();
  return useMemo(() => createApiClient(instance), [instance]);
}
